import { useSelector } from "react-redux"

const useCinemaColorsAndIcons = () => {
    const cinemaData = useSelector((state) => state.toJS().cinemaData)
    const cliData = useSelector((state) => state.toJS().cliData)
    const apiData = useSelector((state) => state.toJS().apiData)
    const cinemasApiData = apiData && apiData.cinemas.items
    const {multiCinemaMode} = cliData
    const {theme} = cinemaData
    const {multitotal_style, theme_colors } = theme

    let cinemaColors = {}

    _.keys(cinemasApiData).map(cinemaPk => {
        const cinema = cinemasApiData[cinemaPk]
        cinemaColors[cinemaPk] = {
            cinemaColor: cinema.scope.cinemaColor,
            cinemaIcon: cinema.scope.cinemaIcon
        }
    })
    
    return {
        cinemaColors: cinemaColors,
        multiCinemaMode: multiCinemaMode,
        themeColors: theme_colors,
        multitotalStyle: multitotal_style
    }
}

export default useCinemaColorsAndIcons